import { CREDIT_PRODUCT } from 'api/advances'
import { Retry } from 'assets/icons'
import RoundedIcon from 'components/RoundedIcon'

const { LOANS } = CREDIT_PRODUCT

const GenerateLineInfo = ({
  className = '',
  isFetching,
  action,
  type
}: {
  className?: string
  isFetching: boolean
  action: () => void
  type: keyof typeof CREDIT_PRODUCT
}) => (
  <div className={`w-full flex gap-2 items-center ${className}`}>
    <div className='w-full'>
      <h4 className='text-2xs font-bold'>Generá tu línea de crédito</h4>
      <p className='text-left font-medium text-[10px]'>
        Averiguá cuánto podémos prestarte
      </p>
    </div>
    <button
      className='w-10 shrink-0 flex items-center justify-end h-10'
      onClick={() => action()}
    >
      <span className='w-full sr-only'>
        consultar línea de {type === LOANS ? 'préstamos' : 'adelantos'}
      </span>
      <RoundedIcon
        className={`${
          isFetching ? 'bg-purple-900/80' : 'bg-purple-900'
        } w-6 h-6`}
        icon={<Retry className={`${isFetching && 'animate-spin-slow'}`} />}
      />
    </button>
  </div>
)

export default GenerateLineInfo
